import {Card} from '@resurs/tron-react';
import '../../styles/general-styles.css';
import './loader.css';

const Loader = () => (
  <div className="container container--fixed px-4">
    <Card className="bg-white" style={{alignItems: 'center', border: 'none'}}>
      <div className="loader" />
    </Card>
  </div>
);

export default Loader;
